// Translation loader. Each locale is a dynamic import so the active region
// only ships its own message bundle to the client.
//
// Maintenance status (as of 2026-05):
//   cz      ACTIVE      — primary locale, source of truth for new keys.
//                         JSON format — translator-tool friendly.
//   sk      ACTIVE      — kept in lockstep with cz. JSON format.
//   at      DEPRECATED  — German/Austrian translations are no longer actively
//   hu      DEPRECATED    maintained, but the .k8s/prod-{at,hu,ro} ingress
//   ro      DEPRECATED    overlays remain live. Do NOT delete these files
//                         without first decommissioning those deployments.
//                         Still in .js because they're frozen and not worth
//                         the migration churn.
//
// `checks/audits/check-locales.ts` audits cz + sk only by default; run
// `npm run check:locales:all` to include the deprecated trio.

function interopDefault(promise) {
    return promise.then((m) => m.default || m)
}

const at = () => interopDefault(import('./at.js'))
const cz = () => interopDefault(import('./cz.json'))
const hu = () => interopDefault(import('./hu.js'))
const ro = () => interopDefault(import('./ro.js'))
const sk = () => interopDefault(import('./sk.json'))

const messages = {
    at,
    cz,
    hu,
    ro,
    sk,
}

export default async function provideMessages(locale) {
    const loadMessages = messages[locale]
    if (!loadMessages) {
        const available = Object.keys(messages).join(', ')
        throw new Error(`Unknown locale "${locale}". Set DEFAULT_LOCALE (in .env) to one of: ${available}.`)
    }
    return await loadMessages()
}
